import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

import Skeleton, { SKELETON_WIDTHS } from '@buyside/components/presentation/Skeleton/skeleton';

import styles from './chatNavigationStyles.scss';

export type NavigationItem = {
  to: string;
  title: string;
  subtitle?: ReactElement;
  unreadMessagesCount?: number;
};

export const ChatNavigationItemLoading: React.FC = () => {
  return (
    <div className={styles.navigationItem}>
      <div>
        <p>
          <Skeleton width={SKELETON_WIDTHS.MEDIUM} />
        </p>
        <p>
          <Skeleton width={SKELETON_WIDTHS.SMALL} />
        </p>
      </div>
    </div>
  );
};

const ChatNavigationItem: React.FC<NavigationItem & {
  onClick: () => void;
}> = ({ to, subtitle, title, onClick, unreadMessagesCount }) => {
  return (
    <NavLink
      className={({ isActive }) =>
        classNames(styles.navigationItem, { [styles.selected]: isActive })
      }
      to={to}
      onClick={onClick}
    >
      <div>
        <div className={styles.title}>
          <p>
            <strong>{title}</strong>
          </p>
          {unreadMessagesCount ? <div>{unreadMessagesCount}</div> : null}
        </div>
        {subtitle}
      </div>
    </NavLink>
  );
};

export default ChatNavigationItem;
